
/**
 * Default font size for body of detail page
 */
export const PDF_FONTSIZE_NORMAL = 10;
export const PDF_FONTSIZE_HEADER = 9;
export const PDF_FONTSIZE_TITLE = 16;
export const PDF_FONTSIZE_SUB_TITLE = 12;
export const PDF_FONTSIZE_TABLE_TITLE = 14;
export const PDF_FONTSIZE_TABLE_TOTAL = 11;
